"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flowsBase = void 0;
var tslib_1 = require("tslib");
var setPreviousLocationFlow_1 = require("./setPreviousLocationFlow");
var authFlows_1 = require("./auth/authFlows");
var closeDropdownF_1 = require("./closeDropdownF");
var errorF_1 = require("./errorF");
var toggleFlowsBase_1 = require("./toggles/toggleFlowsBase");
var patchFlowsBase_1 = require("./patch/patchFlowsBase");
var submitFlowsBase_1 = require("./submit/submitFlowsBase");
var getSessionStorageF_1 = require("./get/getSessionStorageF");
var getCookieStorageF_1 = require("./get/getCookieStorageF");
var getWorkspaceLogoUrlRequestF_1 = require("./get/getWorkspaceLogoUrlRequestF");
var flowsBase = function () {
    return tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray([], authFlows_1.authFlows, true), [
        getSessionStorageF_1.getSessionStorageF,
        getCookieStorageF_1.getCookieStorageF,
        getWorkspaceLogoUrlRequestF_1.getWorkspaceLogoUrlRequestF
    ], false), toggleFlowsBase_1.toggleFlowsBase, true), patchFlowsBase_1.patchFlowsBase, true), submitFlowsBase_1.submitFlowsBase, true), [
        closeDropdownF_1.closeDropdownF,
        errorF_1.errorF,
        setPreviousLocationFlow_1.setPreviousLocationFlow,
    ], false);
};
exports.flowsBase = flowsBase;
